import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Switch,
  Typography,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import ConfirmModal from "../../../components/modal/confirmModal";
import FailModal from "../../../components/modal/failModal";
import { ERR_0013, ERR_0051, SUCCESS_CODE } from "../../../lib/const";
import { splitFullName } from "../../../lib/utils/helper";
import { updateProfile } from "../../../services/profileService";
import { createUser } from "../../../services/userManagement";
import {MultipleAutoComplete} from "../../../components/common/autoCompleteV2";
const { Title } = Typography;

const Option = Select.Option;

const ActionModal = (props) => {
  const {
    open,
    setOpen,
    actionTypeModal,
    setActionTypeModal,
    estates,
    lineOfWork,
    roles,
    editData,
    setEditData,
    setFetchData,
  } = props;

  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const [submittable, setSubmittable] = useState(true);
  const [accStatus, setAccStatus] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const onChangeStatus = (checked) => {
    setAccStatus(checked);
  };

  const onEditData = useCallback(
    (data) => {
      const fullName = splitFullName(data?.fullName);
      if (data?.recStatus === "A") {
        console.log();
        setAccStatus(true);
      } else {
        setAccStatus(false);
      }
      form.setFieldsValue({
        username: data.username,
        firstName: fullName[0] ? fullName[0] : "",
        lastName: fullName[1] ? fullName[1] : "",
        email: data.email,
        roleId: data.roleId,
        description: data.description,
        estateId: data.estateId,
        lineOfWorkId: data.lineOfWorkId,
      });
    },
    [form, setAccStatus]
  );

  useEffect(() => {
    if (Object.keys(editData).length > 0 && actionTypeModal !== "add") {
      onEditData(editData);
    } else {
      setAccStatus(false);
    }
  }, [onEditData, form, setAccStatus, actionTypeModal, editData]);

  const onFinish = async () => {
    setConfirmModal(false);
    const request = {
      userId: editData?.userId,
      username: form.getFieldsValue().username,
      firstname: form.getFieldsValue().firstName,
      lastname: form.getFieldsValue().lastName,
      roleId: form.getFieldsValue().roleId,
      email: form.getFieldsValue().email,
      description: form.getFieldsValue().description,
      accountStatus: accStatus ? "A" : "D",
      estateId: form.getFieldsValue().estateId,
      lineOfWorkId: form.getFieldsValue().lineOfWorkId,
      fromPage: "manage",
    };

    if (actionTypeModal === "add") {
      const res = await createUser(request);
      if (res.data.code === SUCCESS_CODE) {
        setFetchData(true);
        onCancel();
      } else {
        setFailModal(true);
        if (res?.data?.code === "ERR-9999") {
          setErrMsg('เกิดข้อผิดพลาดภายในเซิร์ฟเวอร์');
        } else if (res?.data?.code === ERR_0013) {
          setErrMsg("ระบบไม่สามารถดำเนินการได้ เนื่องจากมีอีเมล์ซ้ำ");
        }else if (res?.data?.code === ERR_0051) {
          setErrMsg("ระบบไม่สามารถดำเนินการส่งเมลได้");
        } else {
          setErrMsg("ขออภัย, มีเกิดข้อผิดพลาดบางอย่าง");
        }
      }
    } else {
      const res = await updateProfile(request);
      if (res.data.code === SUCCESS_CODE) {
        setFetchData(true);
        onCancel();
      } else {
        setFailModal(true);
        if (res?.data?.code === "ERR-9999") {
          setErrMsg('เกิดข้อผิดพลาดภายในเซิร์ฟเวอร์');
        } else if (res?.data?.code === ERR_0051) {
          setErrMsg("ระบบไม่สามารถดำเนินการส่งเมลได้");
        } else {
          setErrMsg("ขออภัย, มีเกิดข้อผิดพลาดบางอย่าง");
        }
      }
    }
  };

  const onCancel = () => {
    setOpen(false);
    setActionTypeModal("");
    setAccStatus(false);
    setEditData({});
    form.resetFields();
  };

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(
        () => {
          setSubmittable(true);
        },
        () => {
          setSubmittable(false);
        }
      );
  }, [values, form]);

  return (
    <>
      <Modal open={open} onCancel={onCancel} footer={false} width={700}>
        <Row justify="center">
          <Col span={24} align="center">
            <Title level={5}>
              {actionTypeModal === "add"
                ? "เพิ่มผู้ใช้งาน"
                : "แก้ไขข้อมูลผู้ใช้งาน"}
            </Title>
          </Col>
        </Row>

        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
          name="validateOnly"
        >
          <Row gutter={[24, 12]}>
            <Col span={12}>
              <Form.Item
                label="ชื่อผู้ใช้ระบบ"
                name="username"
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                <Input
                  placeholder="ชื่อผู้ใช้ระบบ"
                  disabled={actionTypeModal === "add" ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={12}></Col>
            <Col span={12}>
              <Form.Item
                label="ชื่อจริง"
                name="firstName"
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                <Input placeholder="ชื่อจริง" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="นามสกุล"
                name="lastName"
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                <Input placeholder="นามสกุล" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="อีเมล"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                  {
                    type: "email",
                    required: true,
                    message: "รูปแบบอีเมลไม่ถูกต้อง",
                  },
                ]}
              >
                <Input placeholder="Ex.abc@gmail.com,hotmail.com..." />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Role"
                name="roleId"
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                <Select
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  placeholder="กรุณาเลือก Role"
                >
                  {roles.map((item) => (
                    <Option value={item.roleId}>{item.roleNameTh}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="รายละเอียด" name="description">
                <Input.TextArea placeholder="รายละเอียด" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="สถานะ" name="accountStatus">
                <Switch
                  defaultChecked={actionTypeModal === "add" ? true : false}
                  onChange={onChangeStatus}
                  checked={accStatus}
                  disabled={actionTypeModal === "add" ? true : false}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="ชื่อนิคม"
                name="estateId"
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                {/* <Select
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  placeholder="กรุณาเลือกนิคม"
                >
                  {estates.map((item) => (
                    <Option value={item.estateId}>{item.estateNameTh}</Option>
                  ))}
                </Select> */}
                <MultipleAutoComplete
                  multiple={false}
                  subject="estateName"
                  valueField="estateId"
                  labelField="estateNameTh"
                  placeholder="กรุณาเลือก"
                />                
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="สายปฏิบัติงาน"
                name={"lineOfWorkId"}
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                <Select
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  placeholder="กรุณาเลือกสายปฏิบัติงาน"
                >
                  {lineOfWork.map((item) => (
                    <Option value={item.lineOfWork}>{item.nameTh}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Space
            direction="horizontal"
            style={{
              width: "100%",
              justifyContent: "center",
              marginTop: 40,
              marginBottom: 20,
            }}
          >
            <Button key="back_modal" onClick={onCancel}>
              ยกเลิก
            </Button>
            <Button
              type="primary"
              onClick={() => {
                setConfirmModal(true);
              }}
              disabled={!submittable}
            >
              ยืนยัน
            </Button>
          </Space>

          <ConfirmModal
            actionType={"save"}
            title={"ยืนยันการบันทึกข้อมูล"}
            open={confirmModal}
            modalText={"คุณต้องการบันทึกข้อมูล ?"}
            onOk={onFinish}
            onCancel={() => {
              setConfirmModal(false);
            }}
          />

          <FailModal
            open={failModal}
            setOpen={setFailModal}
            subTitle={errMsg}
            setErrMsg={setErrMsg}
          />
        </Form>
      </Modal>
    </>
  );
};

export default ActionModal;
